// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .menu-item {
      display: flex;
      flex-direction: column;
      padding: 0 5px 6px;
    }

    .menu-item-icon {
      width: 31px;
      height: 31px;
      /* aspect-ratio: 1.59; */
      object-fit: cover;
      object-position: center;
      align-self: center;
    }

    .menu-item-label {
      font-family: Nunito, sans-serif;
    }

        .container {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          max-width: 374px;
          font-size: 12px;
          color: #000;
          font-weight: 600;
          white-space: nowrap;
        }

        .logo {
          width: 64px;
          height: 64px;
          border-radius: 100px;
          background-color: #f4bc16;
          align-self: center;
        }

        .menu {
          position: relative;
          display: flex;
          width: 100%;
          margin-top: -30px;
          aspect-ratio: 4.92;
          /* padding: 18px 27px 10px; */
          gap: 20px;
          justify-content: space-between;
          overflow: hidden;
          fill: #eae5d8;
          filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));
        }

        .menu-background {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }



.menu-content {
    position: relative;
    display: flex;
    justify-content: center;
    padding-left: 40px;
    /* padding-top: 10px; */
    gap: 8px;
    align-content: center;
    align-items: center;}

        .profile-image {
          width: 35px;
          aspect-ratio: 1;
          object-fit: cover;
          object-position: center;
          margin: auto 0;
        }

        .profile-section {
          display: flex;
          flex-direction: column;
          padding: 0 7px 6px;
        }

        .profile-icon {
          width: 34px;
          aspect-ratio: 1.41;
          object-fit: cover;
          object-position: center;
          align-self: center;
        }

        .profile-label {
          font-family: Nunito, sans-serif;
        }

        .menu-items {
            position: relative;
            display: flex;
            justify-content: center;
            gap: 8px;
            padding: 0 30px;
            align-items: center;
        }
    `, "",{"version":3,"sources":["webpack://./src/components__old/navbar/navbar.css"],"names":[],"mappings":";IACI;MACE,aAAa;MACb,sBAAsB;MACtB,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,wBAAwB;MACxB,iBAAiB;MACjB,uBAAuB;MACvB,kBAAkB;IACpB;;IAEA;MACE,+BAA+B;IACjC;;QAEI;UACE,aAAa;UACb,sBAAsB;UACtB,qBAAqB;UACrB,gBAAgB;UAChB,eAAe;UACf,WAAW;UACX,gBAAgB;UAChB,mBAAmB;QACrB;;QAEA;UACE,WAAW;UACX,YAAY;UACZ,oBAAoB;UACpB,yBAAyB;UACzB,kBAAkB;QACpB;;QAEA;UACE,kBAAkB;UAClB,aAAa;UACb,WAAW;UACX,iBAAiB;UACjB,kBAAkB;UAClB,6BAA6B;UAC7B,SAAS;UACT,8BAA8B;UAC9B,gBAAgB;UAChB,aAAa;UACb,oDAAoD;QACtD;;QAEA;UACE,kBAAkB;UAClB,QAAQ;UACR,WAAW;UACX,YAAY;UACZ,iBAAiB;UACjB,uBAAuB;QACzB;;;;AAIR;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,QAAQ;IACR,qBAAqB;IACrB,mBAAmB,CAAC;;QAEhB;UACE,WAAW;UACX,eAAe;UACf,iBAAiB;UACjB,uBAAuB;UACvB,cAAc;QAChB;;QAEA;UACE,aAAa;UACb,sBAAsB;UACtB,kBAAkB;QACpB;;QAEA;UACE,WAAW;UACX,kBAAkB;UAClB,iBAAiB;UACjB,uBAAuB;UACvB,kBAAkB;QACpB;;QAEA;UACE,+BAA+B;QACjC;;QAEA;YACI,kBAAkB;YAClB,aAAa;YACb,uBAAuB;YACvB,QAAQ;YACR,eAAe;YACf,mBAAmB;QACvB","sourcesContent":["\n    .menu-item {\n      display: flex;\n      flex-direction: column;\n      padding: 0 5px 6px;\n    }\n\n    .menu-item-icon {\n      width: 31px;\n      height: 31px;\n      /* aspect-ratio: 1.59; */\n      object-fit: cover;\n      object-position: center;\n      align-self: center;\n    }\n\n    .menu-item-label {\n      font-family: Nunito, sans-serif;\n    }\n\n        .container {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-end;\n          max-width: 374px;\n          font-size: 12px;\n          color: #000;\n          font-weight: 600;\n          white-space: nowrap;\n        }\n\n        .logo {\n          width: 64px;\n          height: 64px;\n          border-radius: 100px;\n          background-color: #f4bc16;\n          align-self: center;\n        }\n\n        .menu {\n          position: relative;\n          display: flex;\n          width: 100%;\n          margin-top: -30px;\n          aspect-ratio: 4.92;\n          /* padding: 18px 27px 10px; */\n          gap: 20px;\n          justify-content: space-between;\n          overflow: hidden;\n          fill: #eae5d8;\n          filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));\n        }\n\n        .menu-background {\n          position: absolute;\n          inset: 0;\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          object-position: center;\n        }\n\n\n\n.menu-content {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    padding-left: 40px;\n    /* padding-top: 10px; */\n    gap: 8px;\n    align-content: center;\n    align-items: center;}\n\n        .profile-image {\n          width: 35px;\n          aspect-ratio: 1;\n          object-fit: cover;\n          object-position: center;\n          margin: auto 0;\n        }\n\n        .profile-section {\n          display: flex;\n          flex-direction: column;\n          padding: 0 7px 6px;\n        }\n\n        .profile-icon {\n          width: 34px;\n          aspect-ratio: 1.41;\n          object-fit: cover;\n          object-position: center;\n          align-self: center;\n        }\n\n        .profile-label {\n          font-family: Nunito, sans-serif;\n        }\n\n        .menu-items {\n            position: relative;\n            display: flex;\n            justify-content: center;\n            gap: 8px;\n            padding: 0 30px;\n            align-items: center;\n        }\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
